//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import Scroll from 'vue-slim-better-scroll'
import HeadNav from '@/components/headNav'

export default {
    name:"Comment",
    components:{
        Scroll,
        HeadNav
    },
    data(){
        return {
            list:[],
            query:{
                size:10,
                start:0,
                orderKey:'commentTime',
                desc:'true',
                goodsId:''
            },
            title:'全部评价'
        }
    },
    created(){
        this.query.goodsId = this.$route.params.id || ''
    },
    mounted(){
        this.loadRefresh();
    },
    methods:{
        // 加载刷新数据
        async loadRefresh () {
            this.query.start = 0;
            const data = await this._fetchList()
            // 初始化数据
            this.list = data
        },
        // 加载更多数据
        async loadMore () {
            this.query.start += this.query.size
            const data = await this._fetchList()
            this.list.push(...data)
            this.list.length >= this.totalSize ? this.$refs.scroll.update(true) : this.query.start+=this.query.size // 判断是否已达最后一页?如果已是最后一页，可调用this.$refs.scroll.update(true)关闭上拉
        },
        // 获取列表操作
        async _fetchList () {
            let query = this.query;
            let getData = await axiosApi.getGoodComments(query).then(res=>{
                if(res.code==0){
                    let data = res.content;
                    this.totalSize = data.total;
                    return data.list || [];
                }
            });
            return getData;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/shop/comment.vue